module.exports = __webpack_public_path__ + "img/Logos.59b22ad8.svg";